import {Typography} from 'antd'
import dayjs from 'dayjs'
import Card from 'components/card/Card'
import OrderStatusLabel from 'components/order/OrderStatusLabel'
import {IconArrowLeft} from 'components/icons'
import {IUseOrderCancellation} from '../hooks/useOrderCancellation'
import {rupiahFormat} from '../../../helpers/formatter'

const OrderCancellationDetail = ({orderCancel, handleConfirm}: {
  orderCancel: IUseOrderCancellation,
  handleConfirm: (isApproved: boolean) => void
  }) => {

  return (
    <Card loading={orderCancel.loading} dataTestId="card_orders_detail">
      <Card.Header className="mt-0">
        <button
          data-testid="btn_back_to_list"
          className="bg-transparent border-0 mr-4 cursor-pointer"
          onClick={() => orderCancel.setSelectedOrder(null)}
        >
          {<IconArrowLeft/>}
        </button>
        <Typography.Title className="m-0 text-2xl">Detail Pembatalan</Typography.Title>
      </Card.Header>
      <Card.Body>
        <div className="flex justify-between items-start mb-6">
          <div>
            <Typography.Title className="mt-0 text-lg font-semibold">
              Nomor Pesanan :
              <span className="text-xl text-amber-500 font-bold ml-3">
                {orderCancel.selectedOrder?.id}
              </span>
            </Typography.Title>
            <Typography.Title className="mt-0 text-lg font-semibold">
              Alasan Pembatalan :
              <span className="text-xl font-bold ml-3">
                {orderCancel.selectedOrder?.cancellationReason ?? '-'}
              </span>
            </Typography.Title>
            <Typography.Title className="mt-0 text-lg font-semibold">
              Tanggal :
              <span className="text-xl font-bold ml-3">
                {orderCancel.selectedOrder?.createdAt ? dayjs(orderCancel.selectedOrder?.createdAt).format('DD MMMM YYYY') : '-'}
              </span>
            </Typography.Title>
            <Typography.Title className="mt-0 text-lg font-semibold">
              Total Tagihan :
              {orderCancel.selectedOrder ?
                <span className="text-xl font-bold ml-3">
                  {rupiahFormat(orderCancel.selectedOrder.totalItemPrice)}
                </span> : null}
            </Typography.Title>
            {orderCancel.selectedOrder ? <OrderStatusLabel status={orderCancel.selectedOrder.status}/> : null}
          </div>
          <div className="flex flex-col gap-3">
            <button
              onClick={() => handleConfirm(true)}
              data-testid="btn_confirm_order"
              className="py-4 px-6 bg-primary border-0 rounded-lg text-white font-bold cursor-pointer hover:bg-primary-700 text-sm"
            >
              KONFIRMASI PEMBATALAN
            </button>
            <button
              onClick={() => handleConfirm(false)}
              data-testid="btn_reject_order"
              className="py-4 px-6 bg-white border border-primary rounded-lg text-primary font-bold cursor-pointer text-sm"
            >
              TOLAK
            </button>
          </div>
        </div>
        <Typography.Text className="mb-2 font-bold">Daftar Pesanan</Typography.Text>
        <table className="table-auto w-full mt-2">
          <thead>
          <tr>
            <th className="pl-0 pr-4 py-2 text-sm text-left">Info Produk</th>
            <th className="px-4 py-2 text-sm text-left">Jumlah</th>
            <th className="px-4 py-2 text-sm text-left">Harga Satuan</th>
            <th className="pl-4 pr-0 py-2 text-sm text-left">Total</th>
          </tr>
          </thead>
          <tbody>
          {orderCancel.selectedOrder && orderCancel.selectedOrder.orderItems.map((item) => (
            <tr key={item.id}>
              <td className="border pr-4 pl-0 py-2 text-sm">{item.productName}</td>
              <td className="border px-4 py-2 text-sm">{item.quantity}</td>
              <td className="border px-4 py-2 text-sm">{rupiahFormat(item.productPrice)}</td>
              <td className="border pr-0 pl-4 py-2 text-sm">
                {rupiahFormat(item.quantity * item.productPrice)}
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </Card.Body>
    </Card>
  )
}

export default OrderCancellationDetail